var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageBlock"},[_c('div',{staticClass:"cta-button"},[_vm._t("cta")],2),_c('div',{staticClass:"blockTitle"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"undertext"},[_vm._t("undertext")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }